/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_Sreality_AttrsInputs */

const cs_property_section_sreality_attrs = /** @type {(inputs: Property_Section_Sreality_AttrsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atributy Sreality`)
};

const en_property_section_sreality_attrs = /** @type {(inputs: Property_Section_Sreality_AttrsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality attributes`)
};

/**
* | output |
* | --- |
* | "Sreality attributes" |
*
* @param {Property_Section_Sreality_AttrsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_sreality_attrs = /** @type {((inputs?: Property_Section_Sreality_AttrsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_Sreality_AttrsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_sreality_attrs(inputs)
	return cs_property_section_sreality_attrs(inputs)
});